import { intervalToDuration } from 'date-fns'

const DAY_MS = 86_400_000

export function plural(n: number, forms: [string, string, string]): string {
  const abs = Math.abs(n) % 100
  const tail = abs % 10
  if (abs > 10 && abs < 20) return forms[2]
  if (tail > 1 && tail < 5) return forms[1]
  if (tail === 1) return forms[0]
  return forms[2]
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('ru-RU').format(Math.max(0, Math.round(n)))
}

function pad(n: number): string {
  return String(n).padStart(2, '0')
}

function coarse(from: Date, to: Date): string {
  const d = intervalToDuration({ start: from, end: to })
  const parts: string[] = []
  if (d.years) parts.push(`${d.years} ${plural(d.years, ['год', 'года', 'лет'])}`)
  if (d.months) parts.push(`${d.months} мес`)
  if (parts.length < 2 && d.days) parts.push(`${d.days} ${plural(d.days, ['день', 'дня', 'дней'])}`)
  return parts.join(' ')
}

/** Тикающий каунтдаун до будущей даты. */
export function formatCountdown(target: Date, now: Date): string {
  const ms = target.getTime() - now.getTime()
  if (ms <= 0) return '00:00:00'
  const days = Math.floor(ms / DAY_MS)
  if (days < 60) {
    const rest = ms - days * DAY_MS
    const clock = `${pad(Math.floor(rest / 3_600_000))}:${pad(Math.floor((rest % 3_600_000) / 60_000))}:${pad(
      Math.floor((rest % 60_000) / 1000),
    )}`
    return days > 0 ? `${days} ${plural(days, ['день', 'дня', 'дней'])} · ${clock}` : clock
  }
  return coarse(now, target) || `${days} ${plural(days, ['день', 'дня', 'дней'])}`
}

/** Сколько прошло с момента в прошлом. */
export function formatElapsed(from: Date, now: Date): string {
  const ms = now.getTime() - from.getTime()
  if (ms < 0) return '—'
  if (ms < DAY_MS) return 'идёт сейчас'
  const days = Math.floor(ms / DAY_MS)
  if (days < 60) return `${days} ${plural(days, ['день', 'дня', 'дней'])}`
  return coarse(from, now)
}
